import { Component, h, Prop, Watch } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { UiCmsContactChannelsMiscellaneousBody } from '../../ui-cms-contact-channels/ui-cms-contact-channels-miscellaneous/ui-cms-contact-channels-miscellaneous';

@Component({
  tag: 'ui-cms-contact-channels-miscellaneous-sticky-toolbar',
  styleUrl: 'ui-cms-contact-channels-miscellaneous-sticky-toolbar.scss',
})
export class UiCmsContactChannelsMiscellaneousStickyToolbar {
  @Prop({ mutable: true }) body: UiCmsContactChannelsMiscellaneousBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
  }

  onWriteMessageClick(e) {
    e.stopPropagation();

    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Contact Phone via Sticky Toolbar',
        eventType: 'Action',
      },
      attributes: {
        elementType: 'Button',
        elementLabel: `${this.body.link?.title.replace(/ /g, '_')}`,
        target: this.body.link.src,
      },
      category: {
        area: 'Sticky Toolbar',
      },
    };

    window.ui?.services?.tracking?.track(trackingEvent);
  }

  render() {
    return (
      <div class="channel-contactbox">
        <ui-headline level={3} innerHTML={this.body.headline}></ui-headline>
        <ui-paragraph innerHTML={this.body.text}></ui-paragraph>
        {this.body.link && (
          <ui-link
            href={this.body.link.src}
            class="button"
            button="cta"
            target={this.body.link.target}
            onClick={this.onWriteMessageClick.bind(this)}
          >
            {this.body.link?.title}
          </ui-link>
        )}
      </div>
    );
  }
}
